<template>
    <div>
        <div class="tabs">
            <ul>
                <router-link tag="li" :to="{ name: 'system-content-strings' }" active-class="is-active">
                    <a>Strings</a>
                </router-link>
                <router-link tag="li" :to="{ name: 'system-content-links' }" active-class="is-active">
                    <a>Links</a>
                </router-link>
            </ul>
        </div>

        <div>
            <router-view />
        </div>
    </div>
</template>
<script>
export default {
    name: 'system-content'
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/content/index.vue